import Role from './role';
export default Role;